/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%#= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

require("fetch");

import Asd from "babel-polyfill";
import HomePage from "../components/HomePage";
import AboutUs from "../components/AboutUs";
import PrivacyPolicy from "../components/PrivacyPolicy";
import PlatformGuidelines from "../components/PlatformGuidelines";
import TermsAndConditions from "../components/TermsAndConditions";
import AboutAdvisoryBoard from "../components/AboutAdvisoryBoard";
import AdvisoryBoardChairman from "../components/AdvisoryBoardChairman";
import AdvisoryBoardMembers from "../components/AdvisoryBoardMembers";
import Membership from "../components/Membership";
import NewMembership from "../components/NewMembership";
import CurrentMembers from "../components/CurrentMembers";
import InnovationAreas from "../components/InnovationAreas";
import CorporateMembership from "../components/CorporateMembership";
import CorporateMembers from "../components/CorporateMembers";
import Events from "../components/Events";
import EventSponsors from "../components/EventSponsors";
import ContactUs from "../components/ContactUs";
import YourAccountContainer from "../components/YourAccountContainer";
import ForgotPassword from "../components/ForgotPassword";
import ResetPassword from "../components/ResetPassword";
import MessagesContainer from "../components/MessagesContainer";
import PressReleases from "../components/PressReleases";
import PressRelease from "../components/PressRelease";
import Workshops from "../components/Workshops";

import WebpackerReact from "webpacker-react";

import FoundationPartner from "../components/FoundationPartner";

WebpackerReact.setup({HomePage, AboutUs,PrivacyPolicy,PlatformGuidelines, TermsAndConditions, AboutAdvisoryBoard, AdvisoryBoardChairman, AdvisoryBoardMembers, Membership, NewMembership, CurrentMembers, InnovationAreas, CorporateMembership, CorporateMembers, Events, EventSponsors, ContactUs, YourAccountContainer, ForgotPassword, ResetPassword, MessagesContainer, FoundationPartner, PressReleases, PressRelease, Workshops});



// WEBPACK FOOTER //
// ./app/javascript/packs/application.js